import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TK2UserLookupDM from './TK2UserLookupDM'
import TPrEmployeeSickNoteWalkTimeDM from './TPrEmployeeSickNoteWalkTimeDM'

export default class TPrEmployeeSickNoteWalkDateDM extends Data {
	public static className = 'TPrEmployeeSickNoteWalkDateDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'TimeStamp',
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	DateTo?: Date
	DateFrom?: Date
	PrEmployeeSickNoteRID?: number
	RightGroupId?: number
	TimeStamp?: string
	ChangedOn?: Date
	CreatedOn?: Date
	RID?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	RightGroupIdCalc?: number
	@Type(() => TK2UserLookupDM)
	ChangedById?: TK2UserLookupDM
	@Type(() => TK2UserLookupDM)
	CreatedById?: TK2UserLookupDM
	@Type(() => TPrEmployeeSickNoteWalkTimeDM)
	PrEmployeeSickNoteWalkTimeChild?: TPrEmployeeSickNoteWalkTimeDM[]
}